import React from 'react';
import { GenericListPage } from '../../components/generic';
import { Conversation } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';
import useSWR from 'swr';
import api from '../../services/api';

// Wrapper hook that matches GenericListPage signature
const useConversationsList = (searchParams?: string) => {
  const queryString = searchParams ? `?${searchParams}` : '';
  const { data, error, isLoading, mutate } = useSWR<Conversation[]>(
    `/conversations${queryString}`,
    async (url: string) => {
      const response = await api.get(url);
      return response.data;
    },
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    isLoading,
    mutate,
  };
};

const List: React.FC = () => {
  return (
    <GenericListPage<Conversation>
      useData={useConversationsList}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
